import React, { useState, useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LanguageContext, { strings } from '../../contexts/language';
import AuthContext from '../../contexts/auth';

export default function Login() {
    const { language } = useContext(LanguageContext);
    const t = strings[language] || strings.pt;
    const { signIn } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const redirect = params.get('redirect') || '/salas';

    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [notFound, setNotFound] = useState(false);

    async function submit(e) {
        e.preventDefault();
        if (!email) { setError(t.required_field); return; }
        setLoading(true); setError(''); setNotFound(false);
        try {
            const data = await signIn(email);
            if (!data?.id) { setNotFound(true); setLoading(false); return; }
            navigate(redirect);
        } catch { setError(t.login_error); }
        setLoading(false);
    }

    return (
        <div className="page"><Header />
            <main style={{ flex:1,display:'flex',alignItems:'center',justifyContent:'center',padding:'60px 20px' }}>
                <div style={{ maxWidth:420,width:'100%' }}>
                    <div className="card-glass" style={{ padding:40,borderRadius:20 }}>
                        <h2 className="section-title text-center" style={{ fontSize:22 }}>{t.login_title}</h2>
                        {notFound && (
                            <div className="mb-20" style={{ background:'#fff3cd',borderRadius:10,padding:'14px 18px',color:'#856404',fontWeight:600 }}>
                                {language==='en'?'E-mail not found. Please register first.':'E-mail não encontrado. Por favor, faça sua inscrição primeiro.'}
                                {' '}<Link to="/inscricao" style={{ color:'var(--color-red)' }}>{language==='en'?'Register here':'Inscreva-se aqui'}</Link>
                            </div>
                        )}
                        <form onSubmit={submit} className={loading?'loading':''}>
                            <div className="d-input mb-20" style={{ width:'100%' }}>
                                <label>{t.login_email}</label>
                                <input type="email" value={email} onChange={e=>setEmail(e.target.value)} autoFocus />
                            </div>
                            {error && <div className="error mb-20">{error}</div>}
                            <button type="submit" className="btn-send btn-modern w-100">{loading?'...' : t.login_btn}</button>
                        </form>
                    </div>
                </div>
            </main>
        <Footer /></div>
    );
}
